export const routes = Object.freeze({
    home: '/',
    works: {
        index: '/works',
        show: (slug = ':slug') => `/works/${slug}`,
    },
    newWorks: {
        index: '/new-works'
    },
    collections: {
        index: '/collections',
        show: (slug = ':slug') => `/collections/${slug}`,
    },
    auth: {
        register: 'register',
        login: 'login'
    },
    error: {
        notFound: '/404'
    },
    cart: {
        index: '/cart'
    },
    privacyPolicy: {
        index: '/privacy-policy'
    },
    faq: {
        index: '/frequently-asked-questions'
    },
    termsAndConditions: {
        index: '/terms-and-conditions'
    },
    checkout: {
        success: '/orders/:id'
    },
    contact: {
        index: '/contact'
    },
    articles: {
        index: '/news'
    },
})